<div *ngIf="!showRequest">
  <ng-container >
    
      <h2  class="sectionTitle">{{'ADMIN_USER.CIRCULARS.REJECTION_NOTIFICATION_FORM.FORM_TITLE' | translate}}</h2>
        <app-circular-request  #CircularRequest  (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)"></app-circular-request>
        <form  [formGroup]="RejectionNotificationForm">
          <fieldset [disabled]="formMode == FormMode.Readonly">
           <div class="form-container">
             <div class="form-section">
                <h4 class="section-title">{{'ADMIN_USER.CIRCULARS.REJECTION_NOTIFICATION_FORM.ACTION_TITLE' | translate}}</h4>
                 <!-- Rejection Reason -->
                 <div class="form-group">
                <label for="txtRejectionReason">{{'ADMIN_USER.CIRCULARS.REJECTION_NOTIFICATION_FORM.REJECTION_REASON' | translate}}</label>
                <textarea formControlName="RejectionReason" id="txtRejectionReason" name="RejectionReason"
                    class="form-control"></textarea>
                 </div>
             </div>
           </div>
           <div class="form-container">
              <div *ngIf="formMode == FormMode.Add" class="form-group">
                <button Confirmation (confirmationClick)="onSubmit()"
                   class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SUBMIT' | translate}}</button>
              </div> 
            </div>
          </fieldset>
        </form>  

  </ng-container>
</div>
<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/CircularsTasksDirectory">
        {{ 'FRONT_USER.WORKSPACE.Circulars_TASKS' | translate }}</a></p>

  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
      </div>
  </div>

